const state = {
  isShowExport: false,
  isShowCoverDialog: false,
  customCover: '',
  customWatermark: {
    url: ''
  },
  watermarkType: 'default', // default | none | custom
  watermark: 'default'
}

const getters = {
  isShowExport: state => state.isShowExport,
  isShowCoverDialog: state => state.isShowCoverDialog,
  customCover: state => state.customCover,
  customWatermarkUrl: state => state.customWatermark.url,
  customWatermark: state => state.customWatermark,
  watermarkType: state => state.watermarkType,
  watermark: state => {
    switch (state.watermarkType) {
      case 'default':
        return 'default';
      case 'none':
        return '';
      case 'custom':
        return state.customWatermark.url;
      default:
        return 'default';
    }
  }
}

const mutations = {
  showExport(state, flag) {
    state.isShowExport = flag;
  },
  showCoverDialog(state, flag) {
    state.isShowCoverDialog = flag;
  },
  setCustomCover(state, data) {
    state.customCover = data;
  },
  setCustomWatermark(state, data) {
    state.customWatermark = {
      ...state.customWatermark,
      ...data,
    }
  },
  setWatermarkType(state, data) {
    state.watermarkType = data;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/subtitleExport.js